import classNames from 'classnames';
import Component from './Component';
import immutable from 'immutable';
import React from 'react';
import ReactDOM from 'react-dom';
import uuid from 'uuid';
import {ProgressBar} from 'react-bootstrap';
import ImageList from '../../containers/Image/List';
import ImageEditor from '../../containers/Image/Editor';
import {ModalWindow} from 'reactis-modal';

class ImageUpload extends Component {

	static contextTypes = {
		store: React.PropTypes.object,
	};

	static defaultProps = {
		galleryPicker: false
	};

	constructor(props) {
		super(props);
		this.uid = uuid.v4();
		this.state = {
			busy: false,
			overed: false,
			files: [],
			value: props.value ? props.value.toJS() : null
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({value: nextProps.value ? nextProps.value.toJS() : null});
	}

	componentDidMount() {
		this.uploader = new plupload.Uploader({
			runtimes : 'html5,html4',
			multi_selection: false,
			unique_names: true,
			drop_element: this.uid + "_dropzone",
			browse_button : this.uid + '_pickfiles',
			url : '/upload/image?height=100&width=0',
			filters : {
				max_file_size : '24mb',
				mime_types: [
					{ title : "Image files", extensions : "jpg,jpeg,gif,png"}
				]
			},
			init: {
				FilesAdded: (up, files) => {
					plupload.each(files, (file) => {
						this.handleFileAdd(file);
					});
					this.startUpload();
				},

				FileUploaded: this.handleFileUploaded.bind(this),
				UploadProgress: this.handleUploadProgress.bind(this),
				UploadComplete: this.handleUploadComplete.bind(this),

				Error: function(up, err) {
					alert(err.message);
				},

				init:() => {
					this.uploaderInited = true;
					if (this.uploaderDestroyed) {
						this.uploader.destroy();
					}
				}
			}
		});
		this.uploader.init();
	}

	showImagePicker() {
		const win = new ModalWindow('Vyberte obrázek', <ImageList popup={true} onSelect={(row) => {win.hide(); this.handleSelectImage(row)}} onClose={() => win.hide()} />);
		win.className = 'widemodal';
		win.show(this.context.store.dispatch);
	}

	updateImage(image) {
		const value = immutable.fromJS(image);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	showImageEditor() {
		const win = new ModalWindow('Ořízněte obrázek', <ImageEditor popup={true}
																	 image={this.state.value}
																	 onSave={(image) => {win.hide(); this.updateImage(image)}}
																	 onClose={() => win.hide()} />);
		win.className = 'widemodal';
		win.show(this.context.store.dispatch);
	}

	zoomImage() {
		console.log(this.state.value);
		window.hs.expand(ReactDOM.findDOMNode(this.refs.img), { src: this.state.value.orig});
	}

	handleSelectImage(row) {
		const value = immutable.fromJS({id: row.id, th: row.th, orig: row.orig});
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	componentWillUnmount() {
		if (this.uploaderInited) {
			this.uploader.destroy();
		}
		else {
			this.uploaderDestroyed = true;
		}
	}

	startUpload() {
		this.setState({busy: true});
		this.uploader.start();
	}

	handleFileAdd(file) {
		this.state.files = [];
		this.state.files.push(file);
		this.forceUpdate();
	}

	handleUploadProgress(up, file) {
		this.forceUpdate();
	}

	handleFileUploaded(up, file, response) {
		response = JSON.parse(response.response);
		this.setState({value: {th: response.th, file: response.file, orig: response.orig}});
	}

	handleUploadComplete(up, files) {
		this.setState({busy: false});
		const value = immutable.fromJS(this.state.value);
		if (this.props.onChange) {
			this.props.onChange(value);
		}
		if (this.props.onBlur) {
			this.props.onBlur(value);
		}
	}

	handleClick(e) {
		e.nativeEvent.stopImmediatePropagation();
	}

	handleReset() {
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	}

	dragEnter(e){
		this.setState({overed:true});
	}

	dragLeave(e){
		this.setState({overed:false});
	}

	renderInput() {

		/*var files = this.state.files.map(file => {
			return <span key={file.id}>{file.percent}%</span>
		});*/
		let p;
		if (this.state.files.length) {
			const file = this.state.files[0];
			if (file.status != plupload.DONE) {
				p = <ProgressBar style={{marginTop:10}} bsStyle="success" now={file.percent} label={file.percent + '%'} />
			}
		}

		var preview;
		if (this.state.value) {
			const style = {
				height: this.state.value.th.height,
				width: this.state.value.th.width,
				cursor: 'url(/assets/js/plugins/highslide/graphics/zoomin.cur), auto'
			};
			preview = <div style={{float:'left', position:'relative'}} className="image-gallery">
						<span onClick={() => this.showImageEditor()} className="edit fa fa-crop hidden"></span>
						<span onClick={() => this.handleReset()} className="remove icon-cross"></span>
						<img ref="img" onClick={() => this.zoomImage()} src={this.state.value.th.url} style={style} />
					</div>;
		}

		return 	<div onClick={this.handleClick} className="imageupload">
									<div className="picturepreview">
										{preview}
										<div className="cleaner"></div>
									</div>
									<div id={this.uid + '_dropzone'}
										 onDragEnter={(e) => this.dragEnter(e)}
										 onDrop={(e) => this.dragLeave(e)}
										 onDragLeave={(e) => this.dragLeave(e)}>
										<div id={this.uid + '_pickfiles'} className={classNames('btn btn-default dropzone', {'overed': this.state.overed})}>
											<div style={{pointerEvents: 'none'}}>
												 Vybrat obrázek z disku
											</div>
											<div style={{pointerEvents: 'none', fontSize:10, textAlign:'center'}}>nebo přetáhněte soubor sem</div>
										</div>
										{this.props.galleryPicker && <span style={{verticalAlign:'bottom'}} className="position-right btn btn-default" onClick={() => this.showImagePicker()}>
											<span  className="fa fa-hand-pointer-o position-left"></span>Vybrat z galerie
										</span>}
									</div>
									<div>{p}</div>
				</div>


	}

	renderError() {
		return this.props.error ? (
			React.createElement("span", {className: "error-block", key: "error"},
				this.props.error
			)
		) : null;
	}

	renderWrapper(children) {
		return this.props.wrapperClassName ? (
			React.createElement("div", {className: this.props.wrapperClassName, key: "wrapper"},
				children
			)
		) : children;
	}

	renderFormGroup(children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return (
			React.createElement("div", {className: classNames(classes)},
				children
			)
		);
	}

	render() {
		return this.renderFormGroup([
			this.renderWrapper([
				this.renderInput()
			]),
			this.renderError()
		]);
	}
}

export default ImageUpload;


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/ImageUpload.js